export const MAX_VISIBLE_BIO_CAHRS = 95
